/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import {
  Typography,
  Box,
  Card,
  Fade,
  TextField,
  IconButton,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Instance from "../../../../utils/Axios";
import BASE_URL from "../../../../utils/BASE_URL";
import fileDownload from "js-file-download";

// Components
import ModalDelete from "./components/modalDelete";
import SideDrawer from "./components/drawer";

//Icons
import FeatherIcon from "feather-icons-react";
import pdfIcon from "../../../../assets/images/pdf.png";

//Actions
import GetAllFichasTecnicas from "../../../../utils/redux/actions/energias/fichasTecnicas/GetAllFichasTecnicas";
import GetAllFabricantes from "../../../../utils/redux/actions/energias/fabricantes/GetAllFabricantes";
import GetAllSetores from "../../../../utils/redux/actions/energias/setores/GetAllSetores";

// ############################################################## //
// #####################  Window Dimensions  #################### //
// ############################################################## //

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

const FichasTecnicas = () => {
  const dispatch = useDispatch();
  const [fichaTec, setFichaTec] = useState({
    descricao: "",
    fabricante: "",
    setor: "",
  });
  const dimensions = useWindowDimensions();

  const permissoes = useSelector((state) => state.user.permissoes);

  // ############################################################## //
  // ##########################  Drawer  ########################## //
  // ############################################################## //

  const [drawerWidth, setDrawerWidth] = useState("25vw");
  const [state, setState] = useState({
    right: false,
  });
  const [action, setAction] = useState();
  const toggleDrawer = (anchor, open, action) => {
    if (open == false) {
      setState({ ...state, [anchor]: open });
      setAction(null);
    }
    if (open == true) {
      setState({ ...state, [anchor]: open });
      setAction(action);
    }
  };

  // ############################################################## //
  // ########################  Card Width  ######################## //
  // ############################################################## //

  let cardWidth = "23.5%";
  let spacing = "1.5%";
  if (dimensions.width <= 1500 && dimensions.width > 1150) {
    cardWidth = "31.5%";
  } else if (dimensions.width <= 1150 && dimensions.width > 800) {
    cardWidth = "48.5%";
  } else if (dimensions.width <= 800) {
    cardWidth = "100%";
    spacing = "0%";
  }

  // ############################################################## //
  // ###########################  Search  ######################### //
  // ############################################################## //

  const [filter, setFilter] = useState("");
  const [checked, setChecked] = useState(false);

  const handleChangeChecked = () => {
    setChecked((prev) => !prev);
  };

  const handleChange = (e) => {
    e.preventDefault();

    setFilter(e.target.value);
  };

  const checkFilter = (fichaTec) => {
    if (Object.keys(fichaTec).length > 0) {
      return fichaTec.descricao.toLowerCase().includes(filter.toLowerCase());
    }
    return null;
  };

  // ############################################################## //
  // ########################  Modal Delete  ###################### //
  // ############################################################## //

  const [openDelete, setOpenDelete] = useState(false);
  const [fichaTecId, setFichaTecId] = useState();
  const [loading, setLoading] = useState(false);

  const handleOpen = (e, id) => {
    e.preventDefault();

    setLoading(false);

    setOpenDelete(true);
    setFichaTecId(id);
  };

  const handleClose = (e) => {
    e.preventDefault();
    setOpenDelete(false);
  };

  const [fabricanteId, setFabricanteId] = useState(null);
  const [setorId, setSetorId] = useState(null);

  const fetchFichasTecnicas = (fabricanteId, setorId) => {
    dispatch(GetAllFichasTecnicas(fabricanteId, setorId));
    dispatch(GetAllFabricantes());
    dispatch(GetAllSetores());
  };

  const fichasTecnicas = useSelector(
    (state) => state.fichasTecnicas.fichasTecnicas
  );

  useEffect(() => fetchFichasTecnicas(fabricanteId, setorId), []);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          mx: 5,
          mt: 3,
        }}
      >
        <SideDrawer
          state={state}
          action={action}
          toggleDrawer={toggleDrawer}
          fichaTecId={fichaTecId}
          drawerWidth={drawerWidth}
          dimensions={dimensions}
          fichaTec={fichaTec}
          setFichaTec={setFichaTec}
          fetchFichasTecnicas={fetchFichasTecnicas}
          fabricanteId={fabricanteId}
          setFabricanteId={setFabricanteId}
          setorId={setorId}
          setSetorId={setSetorId}
        />
        <ModalDelete
          openDelete={openDelete}
          handleClose={handleClose}
          fichaTecId={fichaTecId}
          fetchFichasTecnicas={fetchFichasTecnicas}
          // show={show}
          // Loading
          loading={loading}
          setLoading={setLoading}
        />
        <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <h4
                style={{
                  fontSize: "22px",
                  width: "100%",
                }}
                className="text-underline"
              >
                Fichas Técnicas
              </h4>
            </Box>
            <Box sx={{ display: "flex" }}>
              {checked == true ? (
                <Box sx={{ mt: -1 }}>
                  <Fade in={checked}>
                    <TextField
                      onChange={handleChange}
                      label="Pesquisar"
                      variant="standard"
                    />
                  </Fade>
                </Box>
              ) : null}
              <IconButton onClick={handleChangeChecked}>
                <FeatherIcon
                  icon="search"
                  color="#000"
                  size={30}
                  strokeWidth={1.5}
                  checked={checked}
                />
              </IconButton>
              <IconButton onClick={() => toggleDrawer("right", true, "filter")}>
                <FeatherIcon
                  icon="filter"
                  color="#000"
                  size={30}
                  strokeWidth={1.5}
                />
              </IconButton>
              {permissoes.includes("APP_ENERGIAS_FICHASTEC_ADICIONAR") ? (
                <IconButton onClick={() => toggleDrawer("right", true, "add")}>
                  <FeatherIcon
                    icon="plus-square"
                    color="#000"
                    size={30}
                    strokeWidth={1.5}
                  />
                </IconButton>
              ) : null}
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
            }}
          >
            {fichasTecnicas.map(
              (fichaTec) =>
                checkFilter(fichaTec) && (
                  <Card
                    sx={{
                      mb: 5,
                      mr: spacing,
                      boxShadow: "0px 5px 15px lightgrey",
                      width: cardWidth,
                      display: "flex",
                      borderRadius: 2,
                      p: 2,
                    }}
                  >
                    <Box
                      sx={{
                        width: dimensions.width <= 500 ? "25%" : "15%",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        let ficheiro = null;
                        Instance()
                          .get(
                            `${BASE_URL}/energias/fichasTecnicas/${fichaTec.id}`
                          )
                          .then((file) => {
                            console.log(file);
                            ficheiro = file.data.yData[0];

                            return Instance().get(
                              `${BASE_URL}/energias/fichasTecnicas/${fichaTec.id}/download`,
                              { responseType: "blob" }
                            );
                          })
                          .then(({ data }) => {
                            console.log(data, ficheiro);
                            fileDownload(data, ficheiro.ficheiro_nome);
                          })
                          .catch((err) => {
                            console.log(err.response);
                            if (err.response) {
                              if (err.response === 403) {
                                // dispatch(ShowNotification(errorMessage));
                              }
                            }
                          });
                      }}
                    >
                      <img src={pdfIcon} alt="pdf" width={50} />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: dimensions.width <= 500 ? "65%" : "75%",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "17px",
                          fontWeight: "bold",
                        }}
                      >
                        {fichaTec.descricao}
                      </Typography>
                      <Typography sx={{ fontSize: "12px", mt: 2 }}>
                        {fichaTec.fabricante}
                      </Typography>
                    </Box>
                    {permissoes.includes("APP_ENERGIAS_FICHASTEC_REMOVER") ? (
                      <Box sx={{ width: "10%" }}>
                        <IconButton
                          sx={{ mt: -2 }}
                          onClick={(e) => {
                            handleOpen(e, fichaTec.id);
                          }}
                        >
                          <FeatherIcon
                            icon="trash-2"
                            color="#000"
                            size={20}
                            strokeWidth={1.5}
                          />
                        </IconButton>
                      </Box>
                    ) : null}
                  </Card>
                )
            )}
          </Box>
          {/* Footer */}
          {/* <div style={{ margin: "20px 40px" }}>
            <FooterLinks />
          </div> */}
        </Box>
      </Box>
    </>
  );
};

export default FichasTecnicas;
